export const NOT_FOUND_ERROR = "NotFound";
export const USER_NOT_FOUND = "User Not Found";
export const UNABLE_TO_LOGIN =
  "Unable to log User into the System.  Please contact Support at MiViewIS.com";
export const INTERACTION_REQUIRED_ERROR =
  "Your session requires user interaction. Please reload the page to sign in again.";
